import React from 'react';
import { Box, Container, CircularProgress, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import IntervieweeList from './IntervieweeList';
import InterviewList from './InterviewList';
import InterviewDetails from './InterviewDetails';
import AiInstructions from './AiInstructions';
import MyAccount from './MyAccount';
import Dashboard from './mainDashboard';
import InterviewTemplates from './InterviewTemplates';
import ManageAiInstructions from './ManageAiInstructions';
import styles from './AdminDashboard.module.css';

const MainContent = ({
  currentView,
  isLoading,
  error,
  pageVariants,
  pageTransition,
  selectedInterview,
  setSelectedInterview,
  handleNotesChange,
  handleReviewStatusChange,
  handlePrintInterview,
  handleShareInterview,
  handleDeleteClick,
  filteredInterviews,
  handleInterviewClick,
  reviewFilter,
  handleReviewFilterChange,
  newInterviewee,
  setNewInterviewee,
  handleAddInterviewee,
  handleBulkAddOpen,
  handleDeleteSelectedInterviewees,
  interviewees,
  handleDeleteInterviewee,
  selectedInterviewees,
  handleIntervieweeSelect,
  aiInstructions,
  setAiInstructions,
  updateAiInstructions,
  adminData,
  themeMode,
  language,
  handleThemeChange,
  handleLanguageChange,
  setCurrentView,
  dashboardData
}) => {
  return (
    <Box component="main" className={styles.mainContent}>
      <Container maxWidth="lg">
        <AnimatePresence mode="wait">
          {isLoading ? (
            <CircularProgress />
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : currentView === 'interviewees' ? (
            <motion.div
              key="interviewees"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <IntervieweeList
                newInterviewee={newInterviewee}
                setNewInterviewee={setNewInterviewee}
                handleAddInterviewee={handleAddInterviewee}
                handleBulkAddOpen={handleBulkAddOpen}
                handleDeleteSelectedInterviewees={handleDeleteSelectedInterviewees}
                interviewees={interviewees}
                handleDeleteInterviewee={handleDeleteInterviewee}
                selectedInterviewees={selectedInterviewees}
                handleIntervieweeSelect={handleIntervieweeSelect}
              />
            </motion.div>
          ) : currentView === 'interviews' ? (
            <motion.div
              key="interviews"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              className={styles.viewTransition}
            >
              {selectedInterview ? (
                <InterviewDetails
                  selectedInterview={selectedInterview}
                  setSelectedInterview={setSelectedInterview}
                  handleNotesChange={handleNotesChange}
                  handleReviewStatusChange={handleReviewStatusChange}
                  handlePrintInterview={handlePrintInterview}
                  handleShareInterview={handleShareInterview}
                  handleDeleteClick={handleDeleteClick}
                />
              ) : (
                <InterviewList
                  filteredInterviews={filteredInterviews}
                  handleInterviewClick={handleInterviewClick}
                  reviewFilter={reviewFilter}
                  handleReviewFilterChange={handleReviewFilterChange}
                />
              )}
            </motion.div>
          ) : currentView === 'aiInstructions' ? (
            <motion.div
              key="aiInstructions"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              className={styles.viewTransition}
            >
              <AiInstructions
                aiInstructions={aiInstructions}
                setAiInstructions={setAiInstructions}
                updateAiInstructions={updateAiInstructions}
              />
            </motion.div>
          ) : currentView === 'manageAiInstructions' ? (
            <motion.div
              key="manageAiInstructions"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <ManageAiInstructions />
            </motion.div>
          ) : currentView === 'myAccount' ? (
            <motion.div
              key="myAccount"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <MyAccount
                adminData={adminData}
                themeMode={themeMode}
                language={language}
                handleThemeChange={handleThemeChange}
                handleLanguageChange={handleLanguageChange}
              />
            </motion.div>
          ) : currentView === 'dashboard' ? (
            <motion.div
              key="dashboard"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Dashboard setCurrentView={setCurrentView} dashboardData={dashboardData} />
            </motion.div>
          ) : currentView === 'templates' ? (
            <motion.div
              key="templates"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <InterviewTemplates />
            </motion.div>
          ) : null}
        </AnimatePresence>
      </Container>
    </Box>
  );
};

export default MainContent;